import StripeIntegration from './StripeIntegration';
export default StripeIntegration;
